import filter from 'lodash/filter'
import {
    IBACPredesign,
    TGreetingCardDesign,
} from '@/src/modules/build-a-card/types'

export function assembleCategoriesAndFilterDesigns({
    items,
    selectedCategory,
}: {
    items: any[]
    selectedCategory: string
}) {
    const categories: string[] = items.reduce(
        (collector: string[], item: TGreetingCardDesign | IBACPredesign) => {
            const cats = item.categories
            return [...collector, ...cats]
        },
        []
    )
    // This essentially just returns all the unique values in the array. i.e. removes duplicates
    const uniqueCategories = [...new Set(categories)]

    const categorySelectOptions = uniqueCategories.map((category) => {
        return { label: category, value: category }
    })
    const filteredDesigns = filter(items, (design) => {
        return (
            'empty' === selectedCategory ||
            design.categories.includes(selectedCategory)
        )
    })

    return {
        categories: categorySelectOptions,
        filteredDesigns: filteredDesigns,
    }
}